"use client"; // WAJIB ADA karena menggunakan useEffect, useRef, dan useTranslation

import React, { useEffect, useRef } from "react";
import Image from "next/image"; // Import Image Next.js
import { Logos, partnerLogos } from "../../data.js";
import { useTranslation } from "react-i18next";


export default function Hero() {
  const heroRef = useRef(null);
  const { t, i18n } = useTranslation();

  const partnerLogoItems = partnerLogos.map((partner: { id: number; name: string; image: string; alt: string }) => ({
    src: partner.image,
    alt: partner.alt,
    title: partner.name,
  }));

  // Efek Parallax Scroll
  useEffect(() => {
    const el = heroRef.current as HTMLElement | null;
    if (!el) return;

    const onScroll = () => {
      if (window.innerWidth > 768) {
        // window.pageYOffset sudah usang (deprecated), disarankan pakai window.scrollY
        const scrolled = window.scrollY;
        const parallax = scrolled * 0.4;
        el.style.transform = `translateY(${parallax}px)`;
      } else {
        el.style.transform = `none`;
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <header
        id="home"
        className="hero-section mt-0 pt-20 md:pt-2 pb-0 relative"
      >
        <div
          aria-hidden
          className="pointer-events-none absolute -right-32 top-0 -z-0 h-[420px] w-[420px] md:h-[560px] md:w-[560px] rounded-full bg-gradient-to-br from-[#056F90]/45 via-[#3AB6E0]/25 to-transparent blur-[100px]"
        />
        <div className="container hero-container relative z-[1]">
          {/* --- KIRI: TEKS & TOMBOL --- */}
          <div className="hero-content animate-fade-in">
            <h1 className="text-[28px] md:text-[52px] text-black  font-extrabold leading-[1.15] tracking-tight">
              {(() => {
                const title = t("hero.title");
                const highlight = "All-in-One";
                const parts = title.split(highlight);
                return parts.length > 1 ? (
                  <>
                    {parts[0]}
                    <span className="font-script text-[36px] md:text-[64px] font-normal">{highlight} </span>
                    {i18n.language === "en" ? " " : <br />}
                    {parts[1].trimStart()}
                  </>
                ) : (
                  title
                );
              })()}
            </h1>
            <p className="mt-6 text-[14px] md:text-[18px] leading-7 text-slate-700 max-w-2xl">
              {t("hero.desc")}
            </p>

            <div className="flex flex-col md:flex-row gap-3 hero-buttons mt-8">
              <a
                href="https://api.whatsapp.com/send/?phone=6281370000299&text=Hi%2C+I%27d+like+to+book+an+Edunav+demo+session&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                className="border border-2 bg-[#056F90] font-medium text-white border-[#056F90] rounded-md px-6 py-4 hover:opacity-90 transition text-center text-base flex items-center justify-center"
              >
                {t("hero.btn_demo")}
              </a>

              <a
                href="https://api.whatsapp.com/send/?phone=6281370000299&text=Hi%2C+I%27m+interested+in+Edunav.+Can+I+request+a+demo+via+Zoom%3F&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
                className="border border-2 border-[#056F90] text-[#056F90] font-medium rounded-md px-6 py-4 hover:opacity-90 transition text-center text-base flex items-center justify-center"
              >
                {t("hero.btn_zoom")}
              </a>
            </div>

            <p className="mt-14 text-[14px] md:text-[18px] leading-7 text-slate-700 text-center sm:text-left max-w-2xl">
              Tersedia di:
            </p>

            <div className="flex gap-8 h-auto max-w-[300px] grayscale-[25%] opacity-80 mx-auto md:mx-0 md:w-[550px] app-badges mt-5 z-2 ">
              <a
                href="https://play.google.com/store/apps/details?id=eduversal.eduversal_mobile&hl=id"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  src={Logos.playstore}
                  alt="Download Aplikasi Edunav di Google Play Store"
                  width={135}
                  height={40}
                  className="store-badge hover:opacity-90 transition w-[135px] h-auto"
                  style={{ width: "auto", height: "auto" }}
                />
              </a>

              <a
                href="https://apps.apple.com/id/app/edunav/id1616739654"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Image
                  src={Logos.appstore}
                  alt="Download Aplikasi Edunav di Apple App Store"
                  width={135}
                  height={40}
                  className="store-badge hover:opacity-90 transition w-[135px] h-auto"
                  style={{ width: "auto", height: "auto" }}
                />
              </a>
              
            </div>
          </div>

          {/* --- KANAN: GAMBAR HERO --- */}
          <div className="hero-right">
            <Image
              ref={heroRef}
              src={Logos.heroedunav}
              alt="Ilustrasi Dashboard Sistem Informasi Sekolah Edunav"
              width={1500}
              height={1500}
              sizes="(max-width: 800px) 100vw, 960px"
              quality={85}
              className="w-[800px] h-auto z-1 md:scale-120 animate-fade-in"
              priority // PENTING: Pengganti fetchpriority="high". Memberitahu Next.js gambar ini wajib diload pertama kali untuk skor LCP yang baik.
            />
          </div>
        </div>
      </header>

      
    </>
  );
}
